// Uploads stay on the V1 account (this factory is wired to the V1 client in
// api/ltng/index.js). Original V1 path, restored from the pre-cutover code —
// the V2 account's assets module has 0 uploads.
export default function (axios) {
  return {
    getUploads(params) {
      return axios.get('/modules/uploads', params)
    },

    getUpload(id, params) {
      return axios.get(`/modules/uploads/${id}`, params)
    },
  }
}
